import { isLargeDevice } from '@/constants/Layout'

/** Several differences between the setup for different platforms and device sizes depend on knowing whether the custom app header is shown. Sometimes the purpose of code isn't obvious, especially if different files are involved in the multi-platform design. So please reference this on code related to the visibility of the custom app header */
export const homeHasCustomAppHeader = (): boolean => isLargeDevice()
